import { BottomSheet, Icon, Modal, Text } from 'components'

import joinClassNames from 'utilities/joinClassNames'
import { useNavigate } from 'react-router-dom'
import { BankSlip } from '../../../Modals'
import { useToggle } from 'shared/hooks'

import styles from './styles.module.scss'

interface EmptyStateProps {
  accountId: string
}

const EmptyState = ({ accountId }: EmptyStateProps) => {
  const navigate = useNavigate()

  const bankSlip = useToggle()

  return (
    <div>
      <Modal.Root isOpen={bankSlip.isVisible} onClose={bankSlip.hide}>
        <BankSlip accountId={accountId} />
      </Modal.Root>

      <div className={joinClassNames(styles.content, styles.empty)}>
        <Icon name="wallet" width={56} className={styles.wallet} />

        <Text weight="semibold" size="lg">
          Sem forma de pagamento
        </Text>

        <Text
          weight="light"
          size="sm"
          color="element-medium"
          className={styles.instruction}
        >
          Clique no botão abaixo para adicionar e começar a usar seu sistema de
          alarme
        </Text>
      </div>

      <BottomSheet.Root>
        <BottomSheet.Trigger>
          <div className={styles.add}>
            <Icon name="add" color="accent-blue-default" />
            <Text weight="medium" size="md" color="accent-blue-default">
              Adicionar forma de pagamento
            </Text>
          </div>
        </BottomSheet.Trigger>

        <BottomSheet.Content>
          <BottomSheet.Title>Selecione uma opção</BottomSheet.Title>

          <BottomSheet.Option
            onClick={() => navigate(`/credit-card/${accountId}/create`)}
          >
            Cartão de crédito
          </BottomSheet.Option>

          <BottomSheet.Option
            onClick={() => navigate(`/direct-debit/${accountId}/create`)}
          >
            Débito em conta
          </BottomSheet.Option>

          <BottomSheet.Option onClick={bankSlip.show}>
            Boleto
          </BottomSheet.Option>
        </BottomSheet.Content>
      </BottomSheet.Root>
    </div>
  )
}

export default EmptyState
